import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PtaService } from 'src/app/services/pta.service';
import { PtaStepperComponent } from '../pta-stepper/pta-stepper.component';

@Component({
  selector: 'mpp-pta-prompt-modal',
  templateUrl: './pta-prompt-modal.component.html',
  styleUrls: ['./pta-prompt-modal.component.scss'],
  standalone: false,
})
export class PtaPromptModalComponent {
  constructor(
    private dialogRef: MatDialogRef<PtaPromptModalComponent>,
    private dialog: MatDialog,
    private pta: PtaService,
  ) {}

  closeModal(displayLibraryModal: boolean = true): void {
    // Choose to display the Library Modal or not
    if (displayLibraryModal) {
      this.dialogRef.close();
      this.pta.attemptToLaunchLibraryModal();
    } else {
      this.dialogRef.close();
    }
  }

  openPTA(): void {
    // Open PTA Modal but do not launch Library modal in this path
    this.closeModal(false);
    this.pta.recordPTALaunched();
    this.dialog
      .open(PtaStepperComponent, { panelClass: 'pta-dialog' })
      .beforeClosed()
      .subscribe(() => {
        this.pta.attemptToLaunchLibraryModal();
      });
  }
}
